document.addEventListener('DOMContentLoaded', () => {
  const html = document.documentElement;
  const body = document.body;

  function getDrawer() {
    return document.querySelector('[data-cb-filter-drawer]');
  }

  function getForm() {
    return document.querySelector('[data-cb-filter-form]');
  }

  function unlockPage() {
    html.classList.remove('overflow-hidden');
    body.classList.remove('overflow-hidden');
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');

    html.classList.add('overflow-hidden');
    body.classList.add('overflow-hidden');

    initPriceRanges(drawer);
  }

  function closeDrawer() {
    document.querySelectorAll('[data-cb-filter-drawer]').forEach((drawer) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });

    unlockPage();
  }

  function cleanNumber(value, fallback = 0) {
    const number = Number(String(value || '').replace(/,/g, '').replace(/[^\d.]/g, ''));
    return Number.isFinite(number) ? number : fallback;
  }

  function initPriceRanges(scope = document) {
    scope.querySelectorAll('[data-cb-filter-price]').forEach((wrap) => {
      if (wrap.dataset.cbPriceReady === 'true') {
        updatePriceRange(wrap);
        return;
      }

      wrap.dataset.cbPriceReady = 'true';

      const minRange = wrap.querySelector('[data-cb-price-range-min]');
      const maxRange = wrap.querySelector('[data-cb-price-range-max]');
      const minInput = wrap.querySelector('[data-cb-price-input-min]');
      const maxInput = wrap.querySelector('[data-cb-price-input-max]');

      if (!minRange || !maxRange || !minInput || !maxInput) return;

      minRange.addEventListener('input', () => {
        if (Number(minRange.value) > Number(maxRange.value)) {
          minRange.value = maxRange.value;
        }

        minInput.value = Math.round(Number(minRange.value));
        updatePriceRange(wrap);
      });

      maxRange.addEventListener('input', () => {
        if (Number(maxRange.value) < Number(minRange.value)) {
          maxRange.value = minRange.value;
        }

        maxInput.value = Math.round(Number(maxRange.value));
        updatePriceRange(wrap);
      });

      minInput.addEventListener('input', () => {
        minRange.value = cleanNumber(minInput.value, 0);

        if (Number(minRange.value) > Number(maxRange.value)) {
          minRange.value = maxRange.value;
          minInput.value = maxRange.value;
        }

        updatePriceRange(wrap);
      });

      maxInput.addEventListener('input', () => {
        const max = Number(wrap.dataset.max || 0);
        maxRange.value = cleanNumber(maxInput.value, max);

        if (Number(maxRange.value) < Number(minRange.value)) {
          maxRange.value = minRange.value;
          maxInput.value = minRange.value;
        }

        updatePriceRange(wrap);
      });

      updatePriceRange(wrap);
    });
  }

  function updatePriceRange(wrap) {
    const min = Number(wrap.dataset.min || 0);
    const max = Number(wrap.dataset.max || 0);

    const minRange = wrap.querySelector('[data-cb-price-range-min]');
    const maxRange = wrap.querySelector('[data-cb-price-range-max]');
    const minInput = wrap.querySelector('[data-cb-price-input-min]');
    const maxInput = wrap.querySelector('[data-cb-price-input-max]');
    const progress = wrap.querySelector('[data-cb-price-progress]');

    if (!minRange || !maxRange || !minInput || !maxInput || !progress || max <= min) return;

    let minVal = cleanNumber(minRange.value, min);
    let maxVal = cleanNumber(maxRange.value, max);

    minVal = Math.max(min, Math.min(minVal, max));
    maxVal = Math.max(min, Math.min(maxVal, max));

    if (minVal > maxVal) minVal = maxVal;
    if (maxVal < minVal) maxVal = minVal;

    minRange.value = Math.round(minVal);
    maxRange.value = Math.round(maxVal);
    minInput.value = Math.round(minVal);
    maxInput.value = Math.round(maxVal);

    const left = ((minVal - min) / (max - min)) * 100;
    const right = ((maxVal - min) / (max - min)) * 100;

    wrap.style.setProperty('--cb-price-left', `${left}%`);
    wrap.style.setProperty('--cb-price-right', `${100 - right}%`);

    progress.style.left = `${left}%`;
    progress.style.width = `${right - left}%`;
  }

  function buildSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value === '') continue;
      params.append(key, value);
    }

    form.querySelectorAll('[data-cb-filter-price]').forEach((wrap) => {
      const min = Number(wrap.dataset.min || 0);
      const max = Number(wrap.dataset.max || 0);
      const minInput = wrap.querySelector('[data-cb-price-input-min]');
      const maxInput = wrap.querySelector('[data-cb-price-input-max]');

      if (!minInput || !maxInput) return;

      const minName = minInput.getAttribute('name');
      const maxName = maxInput.getAttribute('name');

      const minVal = cleanNumber(minInput.value, min);
      const maxVal = cleanNumber(maxInput.value, max);

      params.delete(minName);
      params.delete(maxName);

      if (minVal > min) params.append(minName, String(Math.round(minVal)));
      if (maxVal < max) params.append(maxName, String(Math.round(maxVal)));
    });

    return params.toString();
  }

  function refreshCustomDrawer(searchParams) {
    const productGrid = document.getElementById('product-grid');
    const root = document.getElementById('CbFilterDrawerRoot');

    if (!productGrid || !root) return Promise.resolve();

    const sectionId = productGrid.dataset.id;
    if (!sectionId) return Promise.resolve();

    const url = `${window.location.pathname}?section_id=${sectionId}${searchParams ? `&${searchParams}` : ''}`;

    return fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const newRoot = parsed.getElementById('CbFilterDrawerRoot');

        if (newRoot) {
          root.innerHTML = newRoot.innerHTML;
          initPriceRanges(root);
        }
      })
      .catch(() => {});
  }

  function applyFilters(event, form) {
    event.preventDefault();

    if (!form) return;

    const searchParams = buildSearchParams(form);

    closeDrawer();

    if (window.FacetFiltersForm && typeof window.FacetFiltersForm.renderPage === 'function') {
      window.FacetFiltersForm.renderPage(searchParams, null);

      refreshCustomDrawer(searchParams).finally(() => {
        closeDrawer();
        unlockPage();
      });

      return;
    }

    window.location.href = `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`;
  }

  function clearAllFilters(form) {
    if (!form) return;

    const sortInput = form.querySelector('input[name="sort_by"]');
    const sortValue = sortInput ? sortInput.value : '';

    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.checked = false;
    });

    form.querySelectorAll('[data-cb-filter-price]').forEach((wrap) => {
      const min = Number(wrap.dataset.min || 0);
      const max = Number(wrap.dataset.max || 0);

      const minRange = wrap.querySelector('[data-cb-price-range-min]');
      const maxRange = wrap.querySelector('[data-cb-price-range-max]');
      const minInput = wrap.querySelector('[data-cb-price-input-min]');
      const maxInput = wrap.querySelector('[data-cb-price-input-max]');

      if (minRange) minRange.value = min;
      if (maxRange) maxRange.value = max;
      if (minInput) minInput.value = min;
      if (maxInput) maxInput.value = max;

      updatePriceRange(wrap);
    });

    if (sortInput) sortInput.value = sortValue;
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cb-mobile-filter-open]')) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-cb-filter-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const chipRemove = event.target.closest('[data-cb-chip-remove]');
    if (chipRemove) {
      event.preventDefault();

      const form = getForm();
      if (!form) return;

      const name = chipRemove.dataset.name;
      const value = chipRemove.dataset.value;

      if (window.CSS && CSS.escape) {
        const input = form.querySelector(`input[name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`);
        if (input) input.checked = false;
      }

      chipRemove.remove();
      return;
    }

    const priceReset = event.target.closest('[data-cb-price-chip-reset]');
    if (priceReset) {
      event.preventDefault();

      const form = getForm();
      if (!form) return;

      form.querySelectorAll('[data-cb-filter-price]').forEach((wrap) => {
        const min = Number(wrap.dataset.min || 0);
        const max = Number(wrap.dataset.max || 0);

        const minRange = wrap.querySelector('[data-cb-price-range-min]');
        const maxRange = wrap.querySelector('[data-cb-price-range-max]');
        const minInput = wrap.querySelector('[data-cb-price-input-min]');
        const maxInput = wrap.querySelector('[data-cb-price-input-max]');

        if (minRange) minRange.value = min;
        if (maxRange) maxRange.value = max;
        if (minInput) minInput.value = min;
        if (maxInput) maxInput.value = max;

        updatePriceRange(wrap);
      });

      priceReset.remove();
      return;
    }

    if (event.target.closest('[data-cb-filter-clear]')) {
      event.preventDefault();
      clearAllFilters(getForm());
      return;
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-cb-filter-form]');
    if (!form) return;

    applyFilters(event, form);
  });

  document.addEventListener('keydown', (event) => {
    const drawer = getDrawer();

    if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  initPriceRanges();
});